import shortId from 'shortid'

export const genShortId = () => shortId.generate()

export const genDocId = () => 'id' + genShortId()
